import React from 'react';
import Image from 'next/image';

const BannerImages = () => (
  <>
    {/* Avtomobil */}
    <div className="absolute -right-40 bottom-0 sm:-right-80 md:-right-25 lg:-right-0">
      <div className="w-112 h-57 sm:w-144 sm:h-73 relative">
        <Image src="/images/car.webp" fill alt="Car" title="Avto test banneri uchun avtomobil" />
      </div>
    </div>

    {/* Driver's license (PRAVA) */}
    <div className="-bottom-30 absolute -right-20 sm:-bottom-25 sm:-right-60 md:-bottom-20 md:right-16">
      <div className="w-86 h-62 relative">
        <Image
          src="/images/driver-license.webp"
          fill
          alt="Driver's license"
          title="Avto test banneri uchun haydovchilik guvohnomasi"
        />
      </div>
    </div>

    {/* Pastdagi sariq belgi */}
    <div className="absolute -bottom-11 -right-55 sm:right-[-1rem] md:-right-10">
      <div className="w-35 h-35 rotate-10 relative">
        <Image
          src="/images/warning-yellow.webp"
          fill
          alt="Driver's license"
          title="Avto test banneri uchun haydovchilik guvohnomasi"
        />
      </div>
    </div>

    {/* Tepadagi "blur"li sariq belgi */}
    <div className="right-30 absolute -top-10">
      <div className="w-30 h-30 -rotate-30 relative blur-[2px]">
        <Image
          src="/images/warning-yellow.webp"
          fill
          alt="Driver's license"
          title="Avto test banneri uchun haydovchilik guvohnomasi"
        />
      </div>
    </div>

    {/* O'rtadagi "blur"li qizil belgi */}
    <div className="right-13 top-25 absolute">
      <div className="w-25 h-25 rotate-30 relative blur-[2px]">
        <Image
          src="/images/warning-red.webp"
          fill
          alt="Driver's license"
          title="Avto test banneri uchun haydovchilik guvohnomasi"
        />
      </div>
    </div>

    {/* Avtomobil orqasida joylashgan qizil belgi */}
    <div className="right-90 absolute top-20">
      <div className="w-30 h-30 -rotate-15 relative">
        <Image
          src="/images/warning-red.webp"
          fill
          alt="Driver's license"
          title="Avto test banneri uchun haydovchilik guvohnomasi"
        />
      </div>
    </div>
  </>
);

export default BannerImages;
